/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Confirm_Password_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Confirm your password" |
*
* @param {Login_Confirm_Password_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const login_confirm_password_placeholder = /** @type {((inputs?: Login_Confirm_Password_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Confirm_Password_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Confirmez votre mot de passe")
	if (locale === "de") return /** @type {LocalizedString} */ ("Bestätigen Sie Ihr Passwort")
	if (locale === "it") return /** @type {LocalizedString} */ ("Conferma la tua password")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Подтвердите свой пароль")
	if (locale === "es") return /** @type {LocalizedString} */ ("Confirma tu contraseña")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("确认密码")
	if (locale === "ja") return /** @type {LocalizedString} */ ("パスワードを確認してください")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अपने पासवर्ड की पुष्टि करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Confirme sua senha")
	return /** @type {LocalizedString} */ ("Confirm your password")
});